import { render, staticRenderFns } from "./BindUid.vue?vue&type=template&id=0b9f4754&scoped=true&lang=pug&"
import script from "./BindUid.vue?vue&type=script&lang=js&"
export * from "./BindUid.vue?vue&type=script&lang=js&"
import style0 from "./BindUid.vue?vue&type=style&index=0&id=0b9f4754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f4754",
  null
  
)

export default component.exports